<template>
  <modal-template
    :title="title"
    type-modal="select_option_modal"
  >
    <div class="modal-content__main">
      <p v-if="!options.length" class="no-content mb-0">Nenhuma opção cadastrada.</p>
      <ul v-else class="list-inline mb-0">
        <li
          v-for="item in options"
          :key="item.id"
          class="option text-left d-flex align-items-center pr-3 py-1"
          :class="{ 'option--selected': item.id === selectedId }"
        >
          <d-checkbox
            toggle
            :checked="item.id === selectedId"
            class="custom-toggle-sm"
            @change="selectItem(item)"
          />
          <span class="option__text" @click="selectItem(item)">{{ item.name }}</span>
        </li>
      </ul>
    </div>
    <div slot="actions" class="modal-content__control">
      <span class="modal-content__hint">
        Ao inserir, o conteúdo atual do campo será substituído pela opção selecionada.
      </span>
      <d-button
        type="button"
        @click="save()"
        class="btn btn-sm btn-primary"
      >Inserir</d-button>
    </div>
  </modal-template>
</template>

<script>
import Events from '_utils/events';
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';
import {
  CONTRACT_ITEM_SELECT,
  _OPEN_SINGLE_SELECT_MODAL_,
  _SET_OBLIGATION_IN_QUOTATION_,
} from '../QuotationModel';

export default {
  name: 'single-option-select-modal',
  components: {
    ModalTemplate,
  },
  data() {
    return {
      type: null,
      index: null,
      selectedId: null,
    };
  },
  computed: {
    config() {
      return CONTRACT_ITEM_SELECT[this.type] || {};
    },
    title() {
      return this.config.title || 'Selecionar opção';
    },
    options() {
      const items = this.$store.state.settings[this.type];
      if (!items || !items.length) return [];
      return items.filter(item => item.id);
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    selectItem(item) {
      this.selectedId = this.selectedId === item.id ? null : item.id;
    },
    save() {
      const selected = this.options.find(item => item.id === this.selectedId);
      if (!selected) {
        this.activeAlert({ message: 'Selecione uma opção para inserir.', theme: 'warning' });
        return;
      }

      Events.$emit(_SET_OBLIGATION_IN_QUOTATION_, {
        obligation: selected.name,
        type: this.type,
        index: this.index,
      });
      this.setToggle({ type: 'select_option_modal', bool: false });
    },
    matchCurrent(value) {
      const current = String(value || '').trim().toLowerCase();
      const match = this.options.find(item => String(item.name || '').trim().toLowerCase() === current);
      this.selectedId = match ? match.id : null;
    },
  },
  mounted() {
    Events.$on(_OPEN_SINGLE_SELECT_MODAL_, ({ type, index, value }) => {
      this.type = type;
      this.index = index;
      this.matchCurrent(value);
    });
  },
  destroyed() {
    Events.$off(_OPEN_SINGLE_SELECT_MODAL_);
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-content__hint {
  color: #6c757d;
  font-size: 0.85rem;
  margin-right: 1rem;
  font-weight: 600;
}
.option {
  cursor: pointer;
}
.option--selected {
  background: #f5f8fa;
}
.option__text {
  flex: 1;
  min-width: 0;
  line-height: 1.5;
}
.custom-toggle-sm {
  margin: 0 0.5rem 0 0;
}
</style>
